// Form
import * as yup from "yup"

export const validationSchema = yup.object().shape({
  price_level_vendor_code: yup.string().label("Price level code").required(),
  price_level_vendor_name: yup.string().label("Price level name").required()
})